import { useLoaderData } from 'react-router';
import { gql } from '@/__generated__';
import { preloadQuery } from '@/apollo/apollo-client';
import { Route } from './+types/route';

export const ProfileStreamsQuery = gql(`
  query ProfileStreamsQuery($username: String!, $limit: Int!, $nextToken: String) {
    userStreams(username: $username, limit: $limit, nextToken: $nextToken) {
      items {
        ...StreamCardFragment
      }
      nextToken
    }
  }
`);

export const profileStreamsLoader = ({
  params: { username },
}: Route.ClientLoaderArgs) => {
  return {
    streamsQueryRef: preloadQuery(ProfileStreamsQuery, {
      variables: { username, limit: 10, nextToken: null },
    }),
  };
};

type LoaderData = ReturnType<typeof profileStreamsLoader>;

export const useProfileStreamsLoaderData = () => useLoaderData() as LoaderData;
